// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { checkoutShippingCarrierServiceStyles } from "@monsma/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.container = {
    gap: 30,
};

checkoutShippingCarrierServiceStyles.carrierGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        padding-right: 40px;
        ${screen("lte", "md")} {
            padding-right: 15px;
        }
    `,
};
checkoutShippingCarrierServiceStyles.serviceGridItem = { width: [12, 12, 6, 6, 6] };
checkoutShippingCarrierServiceStyles.xStyle = {
    deliveryDateContainer: {
        width: [12, 12, 12, 6, 6],
        css: css`
            padding-left: 40px;
            ${screen("lte", "md")} {
                padding-left: 15px;
            }
        `,
    },
    deliveryDateWrapper: {
        css: css`
            background: ${getColor("common.border")};
            border-radius: 4px;
            padding: 20px;
            width: 100%;
        `,
    },
    notifyWrapper: {
        width: 12,
        css: css`
            padding-top: 30px;
        `,
    },
    shippingNotesWrapper: {
        width: 12,
    },
    freightWrapper: {
        css: css`
            border-top: 1px solid ${getColor("common.ui12")};
            margin-top: 30px;
            padding-top: 30px;
            width: 100%;
        `,
    },
    freightQuestionsTitle: {
        css: css`
            font-size: 13px;
            font-weight: bold;
        `,
    },
    freightQuestionsRadioGroup: {
        css: css`
            margin-bottom: 20px;
        `,
    },
    freightMessage: {
        css: css`
            font-size: 10px;
        `,
    },
};
